import axios from 'axios'
import { trackPromise } from 'react-promise-tracker';
import * as CommonVariables from '../../../Common/CommonVariables'

export const GetCaseCategoryList = async() => {
    var result = await trackPromise(
        axios.get(CommonVariables.API_DOMAIN + 'CaseCategory/GetAllCaseCategoryList'), 
        CommonVariables.API_HEADER
    ).then(response => response)
    return result;
}

export const CreateNewCaseCategory = async (caseOriginDet) => {
    //debugger;
    //console.log(JSON.stringify(caseOriginDet))
    var result = await trackPromise(
        axios.post(CommonVariables.API_DOMAIN + `CaseCategory/CreateNewCaseCategory`, 
        JSON.stringify(caseOriginDet), 
        CommonVariables.API_HEADER)
        ).then(response => response);
    return result;
}

export const ActivateDeActivateCaseCategory = async(Id, IsActive) => {
    //debugger;
    var result = await trackPromise(
        axios.get(CommonVariables.API_DOMAIN + `CaseCategory/ActivateDeActivateCaseCategory?caseCategoryId=${Id}&IsActive=${IsActive}`),
        CommonVariables.API_HEADER
    ).then(response => response)
    return result;
}

export const UpdateCaseCategory = async(caseOriginDet) =>{
    var result = await trackPromise(
        axios.post(CommonVariables.API_DOMAIN + 'CaseCategory/UpdateCaseCategory', 
        JSON.stringify(caseOriginDet),
        CommonVariables.API_HEADER)
    ).then(response => response)
    return result;
}